<template>
  <div>请稍等...</div>
</template>

<script>

export default {
  name: 'SpecificLogin',
  data() {
    return {
      requestKey:'ddd',
    }
  },
  async created() {
    if (this.$router.currentRoute.query.subname) {
      await this.getCaptcha();
      this.$store.commit('verifyUserWithoutLogin', { that: this, subname: this.$router.currentRoute.query.subname, key:this.requestKey })

    }
    if (this.$router.currentRoute.query.code) {
      this.$store.commit('verifyUserWithCodeLogin', { that: this, code: this.$router.currentRoute.query.code })
    }
  },
  methods: {
    async getCaptcha() {
      await this.$get('captcha').then((res) => {
        this.requestKey = res.id
      })
    },

  }
}
</script>

<style scoped>

</style>
